(function () {
  'use strict';

  var dataEl = document.getElementById('koebi-pfand-data');
  var PFAND_VARIANT_ID = dataEl ? parseInt(dataEl.dataset.variantId, 10) : null;
  if (!PFAND_VARIANT_ID || isNaN(PFAND_VARIANT_ID)) return;

  // Custom-Etikett-Produkt: Bypass-Adds (Cart-Permalink, direkter /cart/add)
  // umgehen den Editor und tragen keine `_bottle_count`-Property. Für diese
  // Zeilen leiten wir die Flaschenzahl aus der Varianten-Option „Menge" ab,
  // damit das Pfand NIE fehlt — egal über welchen Weg die Zeile reinkommt.
  var CUSTOM_ETIKETT_HANDLE =
    (dataEl && dataEl.dataset.customHandle) || 'dein-etikett-auf-unserem-bier';

  // Keep a reference to the original fetch before any other code patches it
  var _fetch = window.fetch.bind(window);
  var isSyncing = false;
  var syncQueued = false;
  var syncTimer = null;

  function isPfandId(value) {
    return String(value) === String(PFAND_VARIANT_ID);
  }

  function scheduleSync(delay) {
    if (syncTimer) window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      syncTimer = null;
      syncPfand().catch(function (e) {
        console.warn('[koebi-pfand] Sync fehlgeschlagen:', e);
      });
    }, delay || 150);
  }

  // ── Cart UI refresh ────────────────────────────────────────────────────────
  // Welche Sections nach einer Pfand-Mutation neu gerendert werden muessen.
  function collectSectionTargets() {
    var targets = [];
    var mainCartItems = document.getElementById('main-cart-items');
    var mainCartFooter = document.getElementById('main-cart-footer');

    if (mainCartItems && mainCartItems.dataset.id) {
      targets.push({
        id: 'main-cart-items',
        section: mainCartItems.dataset.id,
        targetSelector: '#main-cart-items .js-contents',
        sourceSelector: '.js-contents'
      });
    }
    if (mainCartFooter && mainCartFooter.dataset.id) {
      targets.push({
        id: 'main-cart-footer',
        section: mainCartFooter.dataset.id,
        targetSelector: '#main-cart-footer .cart__blocks',
        sourceSelector: '.cart__blocks'
      });
    }
    if (document.querySelector('cart-drawer')) {
      targets.push({
        id: 'cart-drawer',
        section: 'cart-drawer',
        targetSelector: '#CartDrawer .drawer__inner',
        sourceSelector: '.drawer__inner'
      });
    }
    if (document.getElementById('cart-icon-bubble')) {
      targets.push({
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        targetSelector: '#cart-icon-bubble',
        sourceSelector: '.shopify-section'
      });
    }
    return targets;
  }

  // Gerenderte Section-HTMLs in die Seite schreiben. `sections` ist die Map aus
  // einer Cart-AJAX-Antwort (oder einem /cart?sections-Fetch). `latestCart` ist
  // optional und nur fuer die is-empty-Klassen noetig.
  function applySections(sections, latestCart, targets) {
    if (!sections) return;
    targets = targets || collectSectionTargets();

    targets.forEach(function (target) {
      var html = sections[target.section];
      var current = document.querySelector(target.targetSelector);
      if (!html || !current) return;

      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector(target.sourceSelector);
      if (!next && target.id === 'cart-icon-bubble') next = doc.body;
      if (!next) return;

      if (window.HTMLUpdateUtility) {
        HTMLUpdateUtility.setInnerHTML(current, next.innerHTML);
      } else {
        current.innerHTML = next.innerHTML;
      }
    });

    if (latestCart && typeof latestCart.item_count === 'number') {
      var isEmpty = latestCart.item_count === 0;
      var cartItems = document.querySelector('cart-items');
      var cartFooter = document.getElementById('main-cart-footer');
      var cartDrawer = document.querySelector('cart-drawer');
      var cartDrawerItems = document.querySelector('cart-drawer-items');

      if (cartItems) cartItems.classList.toggle('is-empty', isEmpty);
      if (cartFooter) cartFooter.classList.toggle('is-empty', isEmpty);
      if (cartDrawer) cartDrawer.classList.toggle('is-empty', isEmpty);
      if (cartDrawerItems) cartDrawerItems.classList.toggle('is-empty', isEmpty);
    }
  }

  // Fallback-Refresh (separater Roundtrip) — nur noch genutzt, wenn die
  // Mutation keine Sections mitliefert.
  async function refreshCartUI() {
    try {
      var targets = collectSectionTargets();
      if (targets.length === 0) return;

      var sectionIds = targets.map(function (target) { return target.section; });
      var sectionResp = await _fetch(
        '/cart?sections=' +
          encodeURIComponent(sectionIds.join(',')) +
          '&sections_url=' +
          encodeURIComponent(window.location.pathname)
      );
      var sections = await sectionResp.json();
      var cartResp = await _fetch('/cart.js');
      var latestCart = await cartResp.json();

      applySections(sections, latestCart, targets);
    } catch (e) {
      // Fallback: hard reload on cart page
      if (window.location.pathname === '/cart') window.location.reload();
    }
  }

  // ── Pfand sync ─────────────────────────────────────────────────────────────
  async function syncPfand() {
    if (isSyncing) {
      syncQueued = true;
      return;
    }
    isSyncing = true;

    try {
      do {
        syncQueued = false;
        await syncPfandOnce();
      } while (syncQueued);
    } finally {
      isSyncing = false;
    }
  }

  // Flaschenzahl einer Cart-Zeile robust bestimmen.
  //   1) Primär: vom Editor/Produkt-Button gesetzte `_bottle_count`-Property.
  //   2) Fallback (nur Custom-Etikett): Menge-Option der Variante — fängt
  //      Bypass-Adds ab, die den Editor umgingen und keine Property tragen.
  function bottleCountForLine(item) {
    var bc = parseInt((item.properties && item.properties['_bottle_count']) || 0, 10);
    if (!isNaN(bc) && bc > 0) return bc;

    if (item.handle === CUSTOM_ETIKETT_HANDLE && Array.isArray(item.options_with_values)) {
      for (var i = 0; i < item.options_with_values.length; i++) {
        var opt = item.options_with_values[i];
        if (opt && /menge/i.test(opt.name)) {
          var n = parseInt(opt.value, 10);
          if (!isNaN(n) && n > 0) return n;
        }
      }
    }
    return 0;
  }

  async function syncPfandOnce() {
    var cartResp = await _fetch('/cart.js');
    var cart = await cartResp.json();

    var totalBottles = 0;
    var pfandItem = null;

    cart.items.forEach(function (item) {
      if (item.variant_id === PFAND_VARIANT_ID) {
        pfandItem = item;
      } else {
        totalBottles += bottleCountForLine(item) * item.quantity;
      }
    });

    var currentQty = pfandItem ? pfandItem.quantity : 0;
    if (totalBottles === currentQty) return; // already in sync

    // Pfand-Mutation MIT Section-Rendering in EINEM Request: die Cart-AJAX-API
    // liefert die gerenderten Sections direkt in der Antwort zurueck. Spart den
    // separaten /cart?sections-Roundtrip (der langsamste Teil) → spuerbar
    // schnellere, quasi-Echtzeit-Aktualisierung der Pfand-Zeile.
    var targets = collectSectionTargets();
    var sectionIds = targets.map(function (t) { return t.section; });

    var url, body;
    if (totalBottles === 0 && pfandItem) {
      url = '/cart/change.js';
      body = { id: pfandItem.key, quantity: 0 };
    } else if (totalBottles > 0 && !pfandItem) {
      url = '/cart/add.js';
      body = { items: [{ id: PFAND_VARIANT_ID, quantity: totalBottles }] };
    } else {
      url = '/cart/change.js';
      body = { id: pfandItem.key, quantity: totalBottles };
    }

    if (sectionIds.length) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
    }

    var resp = await _fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });

    var result = null;
    try { result = await resp.json(); } catch (e) {}

    if (result && result.sections) {
      // change.js liefert das volle Cart-Objekt (inkl. item_count); add.js nicht
      // zwingend — dann nur Sections rendern, is-empty ist nach Pfand-Add irrelevant.
      var cartForFlags = (result && typeof result.item_count === 'number') ? result : null;
      applySections(result.sections, cartForFlags, targets);
    } else {
      await refreshCartUI();
    }
  }

  // ── Pre-Commit ──────────────────────────────────────────────────────────────
  // Berechnet das neue Pfand aus dem AKTUELLEN Cart + der gerade ausgeloesten
  // Mengenaenderung und schreibt die Pfand-Zeile SOFORT (ohne Section-Render).
  // Wird VOR der eigentlichen Dawn-Mengenaenderung ausgefuehrt, damit Dawns
  // eigenes Cart-Render bereits das korrekte Pfand enthaelt → Produkt + Pfand
  // aktualisieren in EINEM Render, kein sichtbares Nachzappeln.
  async function preCommitPfand(changeBody) {
    var cartResp = await _fetch('/cart.js');
    var cart = await cartResp.json();
    if (!cart || !Array.isArray(cart.items)) return;

    var changedKey = changeBody.id != null ? String(changeBody.id) : null;
    var changedLine = changeBody.line != null ? parseInt(changeBody.line, 10) : null; // 1-basiert
    var newQty = parseInt(changeBody.quantity, 10);
    if (isNaN(newQty)) return;

    var totalBottles = 0;
    var pfandItem = null;

    cart.items.forEach(function (item, idx) {
      if (item.variant_id === PFAND_VARIANT_ID) {
        pfandItem = item;
        return;
      }
      var qty = item.quantity;
      if (
        (changedKey != null && String(item.key) === changedKey) ||
        (changedLine != null && idx === changedLine - 1)
      ) {
        qty = newQty;
      }
      totalBottles += bottleCountForLine(item) * qty;
    });

    var currentQty = pfandItem ? pfandItem.quantity : 0;
    if (totalBottles === currentQty) return; // schon korrekt → nichts tun

    if (totalBottles === 0 && pfandItem) {
      await _fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: pfandItem.key, quantity: 0 })
      });
    } else if (totalBottles > 0 && !pfandItem) {
      await _fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: PFAND_VARIANT_ID, quantity: totalBottles }] })
      });
    } else if (pfandItem) {
      await _fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: pfandItem.key, quantity: totalBottles })
      });
    }
  }

  // ── Fetch interceptor ──────────────────────────────────────────────────────
  window.fetch = function (url) {
    if (typeof url === 'string') {
      var mutation = /\/cart\/(add|change|update|clear)(\.js)?/.exec(url);

      if (mutation) {
        var options = arguments[1] || {};
        var parsed = null;
        if (options.body) {
          try { parsed = JSON.parse(options.body); } catch (e) {}
        }

        var isPfandOp = false;
        if (parsed) {
          isPfandOp =
            isPfandId(parsed.id) ||
            (parsed.items && parsed.items.some(function (i) { return isPfandId(i.id); }));
        }

        var op = mutation[1];
        var isQtyChange =
          (op === 'change' || op === 'update') &&
          !isPfandOp &&
          parsed &&
          parsed.quantity != null;

        // Mengenaenderung im Warenkorb → Pfand VOR Dawns Render committen.
        // Fehlerrobust: schlaegt der Pre-Commit fehl, laeuft die Original-
        // anfrage trotzdem + reaktiver Sync als Backstop (alte, sichere Logik).
        if (isQtyChange) {
          var origArgs = arguments;
          return (async function () {
            try { await preCommitPfand(parsed); } catch (e) {}
            var resp = await _fetch.apply(window, origArgs);
            // Backstop: war der Pre-Commit korrekt, ist syncPfand ein No-Op
            // (kein Render); sonst zieht es regulaer nach.
            if (resp && resp.ok) scheduleSync(60);
            return resp;
          })();
        }

        // Alle anderen Cart-Mutationen (add aus PDP, clear, …): reaktiver Sync.
        var result = _fetch.apply(window, arguments);
        if (!isPfandOp) {
          result.then(function (response) {
            if (response.ok) scheduleSync(60);
            return response;
          }).catch(function () {
            // The original fetch consumer handles the user-facing error.
          });
        }
        return result;
      }
    }

    return _fetch.apply(window, arguments);
  };

  // Externer Trigger (z.B. koebi-reorder.js): Pfand-Sync explizit anstossen
  // UND auf Abschluss warten koennen, damit die Pfand-Zeile schon VOR einem
  // Redirect serverseitig im Warenkorb liegt (sonst erscheint sie erst nach
  // manuellem Reload). Gibt das Promise von syncPfand zurueck.
  window.koebiPfandSync = function () {
    return syncPfand();
  };

  // Sync on page load (e.g. direct cart URL visit)
  document.addEventListener('DOMContentLoaded', function () {
    scheduleSync(100);
  });
})();
